'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var sprintSpecificNumbers = ['211', '311', '511', '611', '711', '811', '1311', '3223', '7726', '8757', '8353', '8989', '9000', '9016', '9099', '9230', '9999'];
var verizonSpecificNumbers = ['611', '711', '911', '411', '511'];
var startBoundary = /(\s|^|\t|\n|\r)/;
var endBoundary = /(\s|$|\t|\n|\r)/;
var internationalPhoneNumber = /((\(?\+?(\d{1,3})\)?[-.● ]*)?\(?(\d{3})\)?[-.● ]*(\d{3})[-.● ]*(\d{3,4}))/;
var singaporePhoneNumber = /((\(?\+?(\d{1,3})\)?[-.● ]*)\(?(\d{4})\)?[-.● ]*(\d{4}))/;
var numbersPattern = /(\*(67|70|71|72)\+?\d{10})|([\*|\#]\d{1,5})/;

exports.default = new RegExp('(' + startBoundary.source + ')(' + numbersPattern.source + '|' + internationalPhoneNumber.source + '|' + singaporePhoneNumber.source + '|' + sprintSpecificNumbers.join('|') + '|' + verizonSpecificNumbers.join('|') + '})(' + endBoundary.source + ')', 'gi');